import React, { Component } from "react";
import "../YachtDetails/index.css";
import "../BasicInformation/index.css";
import "./index.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

/* Components */
import InitialSetupBase from "../../../../components/InitialSetupBase";

/* Actions */
import { updateUserProfile } from "../../../../redux/actions/user";
import TextInputWithIcon from "../../../../components/TextInputWithIcon";

const PHONE_REGEX = /^[+]?[\d\s().-]{7,}$/;

const isInvalidPhone = (value) => value && value.length > 0 && !PHONE_REGEX.test(value);

class ContactDetails extends Component {

    state = { primaryTouched: false, secondaryTouched: false };

    render() {

        const primary = this.props.user.data.profile.primaryPhone || "";
        const secondary = this.props.user.data.profile.secondaryPhone || "";
        const primaryError = this.state.primaryTouched && isInvalidPhone(primary);
        const secondaryError = this.state.secondaryTouched && isInvalidPhone(secondary);

        return(
            <InitialSetupBase title={"How can we reach you?"} description={"A direct number helps us get in touch quickly when a match comes up."}>
                <div className="margin-top-20px">
                    <TextInputWithIcon value={primary} onChangeText={(e) => this.props.updateUserProfile([{ propName: "primaryPhone", value: e }])} onBlur={() => this.setState({ primaryTouched: true })} placeholder={"Phone Number"} hide={false} type="tel" inputMode="tel" autoComplete="tel" error={primaryError} />
                    {primaryError &&
                        <p className="contact-details-field-error">That doesn't look like a valid phone number.</p>
                    }
                </div>
                <div className="margin-top-20px">
                    <TextInputWithIcon value={secondary} onChangeText={(e) => this.props.updateUserProfile([{ propName: "secondaryPhone", value: e }])} onBlur={() => this.setState({ secondaryTouched: true })} placeholder={"Other Phone Number (Optional)"} hide={false} type="tel" inputMode="tel" autoComplete="tel" error={secondaryError} />
                    {secondaryError &&
                        <p className="contact-details-field-error">That doesn't look like a valid phone number.</p>
                    }
                </div>
            </InitialSetupBase>
        );

    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        initialSetup: state.initialSetup,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators({ updateUserProfile }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetails);